import { Box, SxProps, Theme, Typography, useTheme } from '@mui/material';
import { BORDER_RADIUS, PADDING, SettingsSectionProps } from '.';
import CopyButton from '../../global/CopyButton';
import { sxToObject } from '../../../utils/global/helper';

export default function CopySection({
  copy,
  containerSx,
}: {
  copy: SettingsSectionProps['copy'];
  containerSx?: SxProps<Theme>;
}) {
  const theme = useTheme();

  if (!copy) return null;

  return (
    <Box
      boxSizing="border-box"
      width={{
        xs: '100%',
        sm: 'fit-content',
      }}
      maxWidth="100%"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      gap={2}
      py={1}
      px={PADDING}
      sx={{
        borderRadius: BORDER_RADIUS,
        backgroundColor: theme.palette.lightGrey.main,
        ...sxToObject(containerSx, theme),
      }}>
      <Typography variant="body2" noWrap flexGrow={0}>
        {copy.content}
      </Typography>
      <CopyButton
        content={copy.content}
        onCopy={copy.onCopy}
        disabled={copy.disabled}
      />
    </Box>
  );
}
